const paidSEM = [
  'PLGOOGLECPC',
  'PLGOOGLECPCB',
  'PLGOOGLECPCB',
  'PLGOOGLECPCBSL',
  'PLMSN',
  'PLMSNSL',
  'PLMSNB',
  'PLMSNBSL',
]

const paidSEMNumber = {
  mobile: '1 (833) 322-0956',
  desktop: '1 (833) 322-0942',
}
const dtdDirectNumber = {
  desktop: '1 (855) 940-4266',
  mobile: '1 (855) 940-4224',
}
const defaultPhoneNumber = {
  mobile: '1 (855) 940-4288',
  desktop: '1 (855) 940-4246',
}

export { paidSEM, paidSEMNumber, dtdDirectNumber, defaultPhoneNumber }
